<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div>
    <div class="field">
      <FieldLabel
        :label="$t('dashboardAdmin.blockEditor.bookmarksJson')"
        :help="$t('dashboardAdmin.blockEditor.help.bookmarksJson')"
      />
      <PrimeTextarea
        :model-value="bookmarksJson"
        rows="10"
        class="textarea-json"
        @click="$emit('open-json-editor', 'bookmarks')"
        readonly
        :placeholder="$t('dashboardAdmin.blockEditor.clickToEdit')"
      />
      <small class="hint-text">{{
        $t("dashboardAdmin.blockEditor.jsonFormat")
      }}</small>
    </div>
  </div>
</template>

<script>
import Textarea from "primevue/textarea";
import FieldLabel from "@/components/dashboard/editor/FieldLabel.vue";

export default {
  name: "BookmarksConfig",
  components: {
    PrimeTextarea: Textarea,
    FieldLabel,
  },
  props: {
    bookmarksJson: {
      type: String,
      default: "",
    },
  },
  emits: ["open-json-editor"],
};
</script>

<style scoped>
.field {
  margin-bottom: 1rem;
}

.textarea-json {
  width: 100%;
  font-family: "Courier New", Courier, monospace;
  font-size: 0.875rem;
  cursor: pointer;
}

.hint-text {
  color: var(--p-text-muted-color);
}
</style>
